<script setup lang="ts">
  import { computed } from 'vue';
  import SvgImage from '../SvgImage/SvgImage.vue';
  import type { IllustrationProps } from './Illustration.types';

  const props = withDefaults(defineProps<IllustrationProps>(), {
    alt: '',
    width: 80,
    height: 80,
    inline: undefined,
  });

  const isSvgSource = computed(
    () =>
      /\.svg(\?.*)?$/i.test(props.src) ||
      props.src.startsWith('data:image/svg+xml'),
  );

  const isSvg = computed(() =>
    typeof props.inline === 'boolean' ? props.inline : isSvgSource.value,
  );

  const isDecorative = computed(() => props.alt === '');

  defineOptions({
    inheritAttrs: false,
  });
</script>

<template>
  <SvgImage
    v-if="isSvg"
    :id="id"
    :test-id="testId"
    :image="src"
    :title="isDecorative ? undefined : alt"
    :width="width"
    :height="height"
    :aria-hidden="isDecorative ? 'true' : undefined"
    v-bind="$attrs"
  />
  <img
    v-else
    :id="id"
    :data-testid="testId"
    :src="src"
    :alt="alt"
    :width="width"
    :height="height"
    :aria-hidden="isDecorative ? 'true' : undefined"
    decoding="async"
    v-bind="$attrs"
  >
</template>
